export const setFirstLetterUpperCase = string => {
  return (string.charAt(0).toUpperCase() + string.slice(1))
}